<template>
  <div class="nf_add" @click="jumpToNfh">
    <div class="list_item">
      <div class="top_rank">
        <img
          src="../img/one_icon@3x.png"
          alt=""
          class="rank_img"
          v-if="index == 0"
        />
        <img
          src="../img/two_icon@3x.png"
          alt=""
          class="rank_img"
          v-if="index == 1"
        />
        <img
          src="../img/three_icon@3x.png"
          alt=""
          class="rank_img"
          v-if="index == 2"
        />
        <div class="publish">
          <img :src="nfh.artNfhIcon" alt="" class="city_img" />
        </div>
        <p>{{ nfh.columnName }}</p>
      </div>
      <div class="content">
        <div class="right_text">
          <p>{{ nfh.title }}</p>
          <div class="bottom_text">
            <img src="../img/hot_icon@3x.png" alt="" />
            <span>{{ nfh.hotVal }}热度</span>
          </div>
        </div>
        <!-- 直播 -->
        <div class="left_img">
          <!-- 预告 -->
          <img
            class="liveImg"
            src="../img/tag_teaser@3x.png"
            alt=""
            v-if="nfh.articleType == 6&&nfh.liveInfo.liveStatus == 1"
          />
          <!-- 直播中 -->
          <img
            class="liveImg"
            src="../img/tag_live@3x.png"
            alt=""
            v-if="nfh.articleType == 6&&nfh.liveInfo.liveStatus == 2"
          />
          <!-- 3回顾 -->
          <img
            class="liveImg"
            src="../img/tag_review@3x.png"
            alt=""
            v-if="nfh.articleType == 6&&nfh.liveInfo.liveStatus == 3"
          />
          <img class="tagImg" src="../img/icon_audio@3x.png" alt="" v-if="nfh.articleType==9">
          <img class="tagImg" src="../img/icon_play@3x.png" alt="" v-if="nfh.articleType==2">
          <!-- <img class="liveImg" src="../img/tag_teaser@3x.png" alt="" v-if="nfh.articleType==1">
            <img class="liveImg" src="../img/tag_review@3x.png" alt="" v-if="nfh.articleType==3"> -->
          <img class="pic" :src="nfh.picSmall" alt="" v-if="nfh.picSmall"> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { staticUrl, nanfangIfUrl } from "@/js/url";
import defaultImg from "@/img/nfh_logo.png";
import goldIcon from "@/img/nfhGoldIcon1.png";
import { newOpenApp } from "@/js/newOpenApp";
import { wxAuth } from "@/js/wx";
export default {
  props: {
    nfh: {},
    index: 0,
    isLatest: true, //当前是否是最新一期
    hitList: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      defaultImg,
      goldIcon,
      hasHit: false,
      popularVal: 0
    };
  },
  created() {
    // this.checkHasHit();
  },
  // watch:{
  //   hitList(){
  //     this.checkHasHit();
  //   }
  // },
  methods: {
    checkHasHit() {
      if (this.hitList.indexOf(this.nfh.columnId + "") > -1) {
        this.hasHit = true;
      }
    },
    jumpToNfh() {
      window.location.href = this.nfh.shareUrl;
    }
  }
};
</script>
<style lang="less">
@import url("../less/mixin.less");
.nf_add {
  display: flex;
  flex-direction: row;
  padding-right: 0.2rem;
  margin-top: 0.3rem;
  .list_item {
    border-bottom: 1px solid #eee;
    padding-bottom: 0.24rem;
    width: 100%;
    .top_rank {
      display: flex;
      .rank_img {
        width: 0.7rem;
        height: 0.3rem;
      }
      .publish {
        width: 0.32rem;
        height: 0.32rem;
        border-radius: 50%;
        margin-left: 0.1rem;
      }
      .city_img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      p {
        font-size: 0.22rem;
        color: #999;
        margin-left: 0.12rem;
      }
    }
    .content {
      margin-top: 0.22rem;
      font-size: 0.34rem;
      display: flex;
      color: #333;
      .right_text {
        // flex: 1;
        width: 4.36rem;
        // background: pink;
        p {
          // letter-spacing: 0;
          // text-align: justify;
          line-height: 0.5rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break:break-all;
        }
        .bottom_text {
          margin-top: 0.52rem;
          color: #999999;
          font-size: 0.22rem;
          img {
            width: 0.2rem;
            height: 0.24rem;
          }
        }
      }
      .left_img {
        height: 1.68rem;
        width:2.24rem;
        margin-left: 0.3rem;
        position: relative;
        .pic {
          width: 100%;
          // width:100%;
          height: 100%;
        }
        .tagImg {
          width: 0.6rem;
          height: 0.6rem;
          position: absolute;
          top: 50%;
          right: 50%;
          margin-top: -0.3rem;
          margin-right: -0.3rem;
        }
        .liveImg {
          width: 0.88rem;
          height: 0.36rem;
          position: absolute;
          bottom: 0.1rem;
          right: 0.1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotlistitem.vue